import { readAccessToken } from 'src/api/tokenStore'

export const createProtectedLoader =
  <A extends unknown[]>(loader: (...args: A) => Promise<unknown>) =>
  async (...args: A): Promise<unknown> => {
    if (!readAccessToken()) return null

    return loader(...args)
  }
